module.exports = __webpack_public_path__ + "static/media/pattern--sheep.87c7df27.svg";